import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// import actions
import { releaseActivityCardFocus } from 'js/store/app/App.actions';

// import components
import ButtonBackArrow from 'js/components/button/Button.back-arrow';

const HeaderResults = ({ title }) => {
  const dispatch = useDispatch();
  const activityCardFocus = useSelector((state) => state.app.activityCardFocus);
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const [fullHeight, setFullHeight] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      setFullHeight(headerRef.current.getBoundingClientRect().height);
    }
  }, []);

  return (
    <>
      <div style={{ height: fullHeight || 125 }} />
      <header ref={headerRef} className="header--results" style={{ backgroundColor: '#9DC145' }}>
        <ButtonBackArrow
          action={() => {
            !activityCardFocus && navigate('/find/', { state: { step2: true } });
            activityCardFocus && dispatch(releaseActivityCardFocus(true));
          }}
        />

        <h1>{title}</h1>
      </header>
    </>
  );
};

export default HeaderResults;
